import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTheme } from '@emotion/react';
import {} from 'react';
import { Text } from '../../atoms';
const InfoCard = (props) => {
    const theme = useTheme();
    return (_jsxs("article", { className: props.className, css: { borderRadius: '0.8rem', padding: '1.6rem', background: theme.color.surface, minWidth: props?.minWidth }, children: [_jsx(Text.Body, { as: "h4", css: { fontSize: '1.2rem', margin: 0, marginBottom: '1.6rem' }, children: props.headlineText }), _jsx(Text.Body, { as: "div", alpha: "high", css: { fontSize: '1.4rem', marginBottom: '0.4rem' }, children: props.text }), _jsx(Text.Body, { as: "div", css: { fontSize: '1.2rem' }, children: props.supportingText })] }));
};
export default InfoCard;
//# sourceMappingURL=InfoCard.js.map